const i18n = {
  'site.title': 'МойОпрос',

  'navigation.faq__desktop': 'Часто задаваемые вопросы',
  'navigation.faq__mobile': 'Часто задаваемые вопросы',
  'navigation.login': 'Вход',
  'navigation.sign_up': 'Регистрация',
  'navigation.my_surveys': 'Мои опросы',
  'navigation.my_profile': 'Профиль',
  'navigation.transactions': 'Баланс',
  'navigation.logout': 'Выйти',

  'dialog.signup.title': 'Регистрация',
  'dialog.signup.button__create_account': 'Зарегистрироваться',
  'dialog.signup.hint__email_typo': 'Возможно, вы имели в виду',
  'dialog.signup.hint__email_typo_end': '?',
  'dialog.signup.text__by_clicking_I_agree': 'Я согласен с %policy1%, %policy2% и даю %policy3%',
  'dialog.signup.link__privacy_policy': 'Политикой конфиденциальности',
  'dialog.signup.link__personal_data': 'Согласие на обработку моих персональных данных',
  'dialog.signup.link__terms_and_conditions': 'Условиями использования',
  'dialog.signup.text__have_an_account_q': 'Уже зарегистрированы?',
  'dialog.signup.link__log_in': 'Вход',
  'dialog.signup.continue_registration': 'Продолжить регистрацию',
  'dialog.signup.continuation_message': 'Обнаружена незавершенная регистрация',
  'dialog.signup.continue': 'Продолжить',
  'dialog.signup.error_message__member_already_exist': 'Пользователь с таким email уже существует',
  'dialog.signup.error_message__unknown_error': 'Что-то пошло не так. Попробуйте позже',
  'dialog.signup.hint__password_requirements': 'Минимум 8 символов, включая латинские буквы и цифры',
  'dialog.signup.error_message__token_expired': 'Срок действия ссылки истек. Пожалуйста, запросите новую ссылку для подтверждения',

  'dialog.post_signup.title': 'Спасибо за регистрацию в МойОпрос',
  'dialog.post_signup.text__description': 'Мы отправили письмо на указанный Вами адрес ',
  'dialog.post_signup.text__footer':
    'Пожалуйста, перейдите по ссылке в письме для активации аккаунта',

  'dialog.any.button__ok': 'ОК',

  'dialog.session_key.title': 'Подтверждение регистрации',
  'dialog.session_key.title_login': 'Подтверждение авторизации',
  'dialog.session_key.subtitle': 'Введите ваш проверочный код',
  'dialog.session_key.description_1': 'Код подтверждения отправлен на ',
  'dialog.session_key.verifying': 'Проверка...',
  'dialog.session_key.verify_button': 'Подтвердить',
  'dialog.session_key.send_again_button': 'Отправить ещё раз',
  'dialog.session_key.sending': 'Отправка...',
  'dialog.session_key.new_code_sent': 'Новый код отправлен',
  'dialog.session_key.limit_exceeded': 'Лимит исчерпан',
  'dialog.session_key.contact_support': 'Обратитесь в службу поддержки',
  'dialog.session_key.paste_error': 'Не удалось вставить код',
  'dialog.session_key.error_limit_exceeded': 'Превышен лимит запросов',
  'dialog.session_key.error_incomplete': 'Введите все 6 цифр кода',
  'dialog.session_key.error_invalid': 'Неверный код подтверждения',
  'dialog.session_key.error_network': 'Ошибка соединения',
  'dialog.session_key.error_resend': 'Ошибка при отправке',
  'dialog.session_key.resend_available_in': 'Отправка возможна через %time%',
  'dialog.session_key.attempts_remaining_1': 'Осталась %count% попытка',
  'dialog.session_key.attempts_remaining_2': 'Осталось %count% попытки',
  'dialog.session_key.attempts_remaining_5': 'Осталось %count% попыток',
  'dialog.session_key.error_session_key_expired': 'Срок действия кода истек. Запросите новый код, чтобы продолжить регистрацию',
  'dialog.session_key.error_session_key_expired__login': 'Срок действия кода истек. Запросите новый код, чтобы продолжить авторизацию',
  'dialog.session_key.error_session_key_expired__change_password': 'Срок действия кода истек. Запросите новый код, чтобы продолжить смену пароля',
  'dialog.session_key.long_block_message': 'Превышен лимит запросов. Запросите новый код, чтобы продолжить регистрацию',
  'dialog.session_key.long_block_message__login': 'Превышен лимит запросов. Запросите новый код, чтобы продолжить авторизацию',
  'dialog.session_key.long_block_message__change_password': 'Превышен лимит запросов. Запросите новый код, чтобы продолжить смену пароля',
  'dialog.session_key.long_resend_limit_exceeded': 'Превышен лимит запросов. Вы можете запросить код подтверждения повторно после истечения таймера или обратиться в поддержку ',
  'dialog.session_key.error_password_change_data_not_found': 'Данные для смены пароля не найдены',
  'dialog.session_key.error_saved_auth_data_not_found': 'Данные для подтверждения авторизации не найдены',
  'dialog.session_key.error_member_already_active': 'Учетная запись уже активирована',
  'dialog.session_key.error_invalid_login_password': 'Неверный логин или пароль',



  'dialog.password_recovery.title': 'Восстановление пароля',
  'dialog.password_recovery.description':
    'Введите свой email, и мы отправим вам ссылку на смену пароля',
  'dialog.password_recovery.placeholder__your_email': 'Ваш email',
  'dialog.password_recovery.button__send_a_link': 'Отправить ссылку',
  'dialog.password_recovery.text__remembered_q': 'Вспомнили?',
  'dialog.password_recovery.link__back_to_login': 'Назад ко входу',
  'dialog.password_recovery.notification__success':
    'Инструкция по восстановлению пароля отправлена на указанную почту',
  'dialog.password_recovery.error_message__unknown_error':
    'Что-то пошло не так. Попробуйте восстановить пароль позже',

  'dialog.inactive_account.text__message': 'Аккаунт неактивен',

  'dialog.stop_reminder.description': 'Вы успешно отменили подписку на приглашения к этому опросу',

  'dialog.unsubscribe.description':
    'Пожалуйста, подтвердите, что вы хотите отказаться от участия в проекте МойОпрос и удалить свою учетную запись. Обратите внимание, что все ваши баллы будут аннулированы.',
  'dialog.unsubscribe.button__delete': 'Да, удалите мою учетную запись',

  'common.notification__we_use_cookies':
    'We use cookies. By clicking "Ok" button you accept our %value% <a>Cookies Policy</a>. Please use "Opt-out option" column of Cookies Policy to customize settings',
};

export default i18n;
